<h2 class="text-center" mat-dialog-title>
  {{ type === 'recommendation' ? ('CASES.single.documents.ai_vision_result.ai_recommendation' | translate)
  : ('CASES.single.documents.ai_vision_result.ai_summary' | translate) }}
</h2>

<mat-dialog-content>
  <ng-container *ngIf="aiVisionResult; else noResults">
    <div class="content-section" *ngIf="type === 'summary'">
      <h3>Summary</h3>
      <p>{{ aiVisionResult.summary || 'No summary available.' }}</p>
    </div>

    <div class="content-section" *ngIf="type === 'recommendation'">
      <h3>{{'CASES.single.documents.ai_vision_result.suggested_doc_type' | translate}}</h3>

      <div class="highlight-box d-flex flex-row justify-content-between align-items-baseline">
        <p class="m-0">{{ aiVisionResult.suggested_doc_type || 'No recommendation available.' }}</p>
        <button *ngIf="!aiVisionResult.doc_type_confirmed" mat-button color="primary"
                (click)="confirmDocType(aiVisionResult.suggested_doc_type)">
          {{'SHARED.confirm' | translate}}
        </button>
      </div>

      <!-- Category -->
      <span class="doc-type-category">
        {{'CASES.single.documents.ai_vision_result.document_type_category' | translate}}:
        <strong>{{ fileCategory.name_es || 'Unknown' }}</strong>
      </span>

      <hr class="my-2" *ngIf="aiVisionResult.doc_type_confirmed || aiVisionResult.confirmed_doc_type_by_user_id">

      <!-- AI Confirmed -->
      <ng-container
        *ngIf="aiVisionResult.doc_type_confirmed && !aiVisionResult.confirmed_doc_type_by_user_id;">
        <div class="confirmed-section">
          <mat-icon class="confirmed-icon">check_circle</mat-icon>
          <span>{{'CASES.single.documents.ai_vision_result.ai_confirmed' | translate}}</span>
        </div>
      </ng-container>

      <!-- User Confirmed -->
      <ng-container
        *ngIf="aiVisionResult.doc_type_confirmed && aiVisionResult.confirmed_doc_type_by_user_id;">
        <div class="confirmed-section">
          <mat-icon class="confirmed-icon">check_circle</mat-icon>
          <span>{{'CASES.single.documents.ai_vision_result.user_confirmed' | translate}}</span>
        </div>
      </ng-container>
    </div>

  </ng-container>

  <ng-template #noResults>
    <div class="no-results">
      <mat-icon color="warn">error_outline</mat-icon>
      <p>{{'CASES.single.documents.ai_vision_result.no_result' | translate}}.</p>
    </div>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close color="primary">{{'SHARED.close' | translate}}</button>
</mat-dialog-actions>
